import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePrevious } from "@hooks/usePrevious.js";
//utilities
import { eraseCookie } from "@utils/browser-helpers";
import { getJWT } from "@utils/browser-helpers";
import { isURLAValidPage } from "@utils/navigation-helpers";
// assets
import IconTriangle from "@assets/icons/IconTriangle";
import { opacity87 } from "@styles/synchrony-core-palette.js";

const styles = {
  syf_navbar: "w-full font-body",
  syf_unorder: "m-0 p-0 list-none",
  syf_unorder_li_ul:
    "rounded-md invisible origin-top scale-y-0 transition-transform duration-300 ease-out opacity-0 absolute h-0 right-0",
  syf_navbar_list_item: "text-opacity-87 !no-underline",
  syf_unorder_clicked: "!visible !scale-y-100 !h-auto !opacity-100",
  syf_navbar_list:
    "block text-opacity-87 text-center relative no-underline duration-100",
  syf_navbar_list_a: "outline-0 p-0 items-center",
  index_header_name:
    "hover:bg-color-marigold hover:rounded-md hover:cursor-pointer hover:text-white focus:bg-color-marigold focus:rounded-md focus:cursor-pointer !focus:text-white",
  index_header_name_a: "py-4 px-0",
};

const Header = () => {
  // Custom Hook
  const sessionDetails = useSelector((state) => state.config.sessionDetails);
  const [sideNavPage, setSideNavPage] = useState(() => "");
  const [headerNameClicked, setHeaderNameClicked] = useState(false);
  const [localUsername, setLocalUsername] = useState("");
  const prevHeaderNameClicked = usePrevious(headerNameClicked);
  const localPage = location.pathname.split("/")[1];

  const { firstName, lastName } = sessionDetails || {};

  const logOut = async () => {
    localStorage.clear();
    try {
      let cookieNames = Object.keys(this.props.cookieObj);
      for (let cookieName in cookieNames) {
        eraseCookie(cookieNames[cookieName]);
      }
      return await fetch("logout", {
        method: "GET",
        credentials: "same-site",
        redirect: "follow",
      });
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    const currentPage = location.pathname.split("/")[1];
    let sidePage = isURLAValidPage(currentPage);
    setSideNavPage(sidePage.page);
    setLocalUsername(getJWT().username);
  }, []);

  useEffect(() => {
    if (!prevHeaderNameClicked && headerNameClicked) {
      document.addEventListener("click", handleOutsideClick, true);
    }
  }, [headerNameClicked]);

  const handleClick = () => {
    if (headerNameClicked) {
      document.removeEventListener("click", handleOutsideClick, true);
    }
    setHeaderNameClicked(!headerNameClicked);
  };

  const handleOutsideClick = (e) => {
    e.stopPropagation();
    if (headerNameClicked) {
      document.removeEventListener("click", handleOutsideClick, true);
    }
    setHeaderNameClicked(false);
  };

  const {
    syf_navbar,
    syf_unorder,
    syf_navbar_list_item,
    syf_unorder_li_ul,
    syf_unorder_clicked,
    syf_navbar_list,
    syf_navbar_list_a,
    index_header_name,
    index_header_name_a,
  } = styles;

  return (
    <div
      id="syf-navbar-navigation"
      className={`${syf_navbar} syf-navbar-fixed-top my-6 mx-auto`}
    >
      <div className="syf-header-right">
        <ul
          id="syf-navbar-content"
          className={`${syf_navbar} ${syf_unorder} flex justify-end`}
        >
          <li
            id="syf-navbar-list"
            className={`${syf_navbar_list} callout z-[1001] justify-self-end`}
            onClick={() =>
              !headerNameClicked ? handleClick(!headerNameClicked) : null
            }
          >
            <div
              className={`${index_header_name} callout p-4 flex justify-center w-auto ${headerNameClicked ? "!text-white bg-color-marigold" : ""
                }`}
              id="index-header-name"
            >
              {firstName && lastName
                ? `${firstName} ${lastName}`
                : localUsername
                  ? localUsername
                  : "User Name"}
              <div className="w-[8px] h-[8px] ml-[5px] mt-1.5">
                <IconTriangle
                  iconFillColor={opacity87}
                  className={"ml-[3px]"}
                />
              </div>
            </div>
            <ul
              className={`syf-dropdown-menu ${syf_unorder} ${syf_unorder_li_ul} ${headerNameClicked ? syf_unorder_clicked : ""
                } w-48 !mt-2 !p-4 bg-white shadow-sm6`}
              id="syf-dropdown-menu"
              aria-label=""
            >
              <li id="syf-navbar-list" className={syf_navbar_list}>
                <a
                  className={`${syf_navbar_list_item} ${syf_navbar_list_a}`}
                  id="switch-clients"
                  href="/select-clients"
                >
                  <div
                    className={`${index_header_name} ${index_header_name_a} callout`}
                  >
                    Switch Client
                  </div>
                </a>
              </li>
              {/* TODO: Include this redirect link if business requires it ->
                  LINK: https://ssoqa.synchronyfinancial.com/login/signout?fromURI=location.origin
               */}
              <li id="syf-navbar-list" className={syf_navbar_list}>
                <a
                  className={`${syf_navbar_list_item} ${syf_navbar_list_a}`}
                  id="logout"
                  onClick={() => logOut()}
                  href="/logout"
                >
                  <div
                    className={`${index_header_name} ${index_header_name_a} callout`}
                  >
                    Logout
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
